import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Lock } from 'lucide-react';
import { getApiBase } from '../utils/apiBase';
import { Link } from 'react-router-dom';

const API = getApiBase();

/**
 * Resolves /t/:token from Memorial QR scans — no raw UUIDs in QR URLs.
 */
export default function TributeTokenRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/public/tribute/${token}`);
        if (cancelled) return;
        if (data.action === 'redirect' && data.url) {
          const path = data.url.replace(/^https?:\/\/[^/]+/, '');
          navigate(path, { replace: true });
        } else {
          setError('This memorial link could not be opened.');
        }
      } catch {
        if (!cancelled) setError('This memorial link is not available.');
      }
    })();
    return () => { cancelled = true; };
  }, [token, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[hsl(42_28%_98%)] px-6 text-center">
        <Lock className="h-10 w-10 text-muted-foreground" aria-hidden />
        <p className="font-serif text-lg text-[hsl(24_14%_18%)]">{error}</p>
        <Link to="/" className="text-sm text-[#8b7355] underline-offset-4 hover:underline">Return home</Link>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-[hsl(42_28%_98%)]">
      <Loader2 className="h-8 w-8 animate-spin text-[#8b7355]" aria-label="Opening memorial link" />
    </div>
  );
}
